import React, { memo, MouseEvent } from 'react';

import cx from 'classnames';
import { get, isNil } from 'lodash';

import { ICON_NAME_VS_CMP } from './constants';

import styles from './icon.module.scss';

interface IconProps {
  type?: string | React.ReactNode;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  className?: string;
  style?: React.CSSProperties;
}

// className, style, onClick

const Icon = (props: IconProps) => {
  const { type, onClick, style, className, ...rest } = props;

  if (!type) return null;

  if (typeof type !== 'string') {
    return (
      <div onClick={onClick} className={cx(styles.icon, className)} style={style}>
        {type}
      </div>
    );
  }

  const RenderIcon = get(ICON_NAME_VS_CMP, type, null);

  if (isNil(RenderIcon)) {
    return null;
  }

  return (
    <div className={cx(styles.icon, className)} onClick={onClick} style={style}>
      {/* disable ts for next line */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <RenderIcon {...rest} />
    </div>
  );
};

export default memo(Icon);
